import React from "react";

type BadgeSize = "large" | "medium" | "small";
type BadgeVariant = "default" | "neutral";
type BadgeRadius = "small" | "medium";

export interface BadgeProps {
  size?: BadgeSize;
  variant?: BadgeVariant;
  radius?: BadgeRadius;
  leftContent?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

const sizeToClasses: Record<BadgeSize, string> = {
  small: "text-[10px] px-1.5 py-0.5",
  medium: "text-[10px] px-2 py-1",
  large: "text-[12px] px-3 py-1.5",
};

const variantToClasses: Record<BadgeVariant, string> = {
  default: "bg-purple-600 text-white",
  neutral: "bg-[#EBEEF4] text-[#585B7A]",
};

const radiusToClasses: Record<BadgeRadius, string> = {
  small: "rounded-[6px]",
  medium: "rounded-full",
};

export default function Badge({
  size = "medium",
  variant = "default",
  radius = "small",
  leftContent,
  className = "",
  children,
}: BadgeProps) {
  // Don't apply default size classes if custom className is provided
  const sizeClasses = className ? "" : sizeToClasses[size];

  return (
    <div
      className={`${variantToClasses[variant]} ${radiusToClasses[radius]} font-bold ${sizeClasses} flex items-center gap-1 ${className}`}
    >
      {leftContent && <span className="flex items-center">{leftContent}</span>}
      <span>{children}</span>
    </div>
  );
}
